module.exports = __webpack_public_path__ + "media/images/homepage/bg-intro-df3012925653ed6a185d86b07a41eaa5.jpeg";